/**
 * Where should a freshly-authenticated user land?
 *
 * Rule (choice 3.b from 25-Jul-2026): a **pure super_admin** — someone
 * with `platform_role: "super_admin"` and NO workspace-level roles like
 * owner/admin — is dropped on `/platform` because they don't own any
 * org data to browse. Everyone else, including super_admins who ALSO
 * happen to be a workspace admin (mixed identity), still lands on the
 * workspace dashboard as before.
 *
 * This is a "soft" default: super_admins can still type `/dashboard`
 * or any other workspace URL in the address bar and they'll be served.
 * We just avoid parachuting them into a workspace they don't belong to
 * on login.
 */
export function landingPathFor(user) {
  const roles = Array.isArray(user?.roles) ? user.roles : [];
  const hasWorkspaceRole = roles.some(r => r && r !== "super_admin");
  if (user?.platform_role === "super_admin" && !hasWorkspaceRole) {
    return "/platform";
  }
  return "/dashboard";
}
